import TagManager from 'react-gtm-module';
import { config } from 'config';
import { createRoot } from 'react-dom/client';
import { StrictMode } from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { theme } from 'assets/themes/zizzi';
import { BrowserRouter } from 'react-router-dom';
import App from './app';
import registerServiceWorker from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

TagManager.initialize({ gtmId: config.gtmId });
const rootElement = document.getElementById('root');

if (!rootElement) throw new Error('No root element in HTML');

const root = createRoot(rootElement!);

root.render(
  <StrictMode>
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <CssBaseline />
        <App />
      </BrowserRouter>
    </ThemeProvider>
  </StrictMode>
);

/** @see https://cra.link/PWA */
registerServiceWorker();

/** @see https://bit.ly/CRA-vitals */
reportWebVitals();
